module.exports = __webpack_public_path__ + "img/icon-face_id.59dcea9a.svg";